import { createContext, ReactNode } from "react";
import TaxationStore from "./taxationStore";
import { observer, useLocalObservable } from "mobx-react";
import { AuthContext } from "../Auth/auth.provider";
import useStore from "../../helpers/useStore";
import { TaxationApi } from "../../api-client";
import { createApiConfig } from "../../api/createApiConfig";

interface TaxationProviderProps {
  children: ReactNode;
}

export const TaxationContext = createContext<TaxationStore | null>(null);
TaxationContext.displayName = "TaxationContext";

export const TaxationProvider = observer(({ children }: TaxationProviderProps) => {
  const AuthenticationStore = useStore(AuthContext);

  const config = createApiConfig();

  const apiClient = new TaxationApi(config);
  const store = useLocalObservable(() => new TaxationStore(apiClient, AuthenticationStore));

  return <TaxationContext.Provider value={store}>{children}</TaxationContext.Provider>;
});
